import { FallbackProps } from 'react-error-boundary';
import { Help } from '@mui/icons-material';
import { Box, Card, ListItem } from '@mui/material';
import { DesktopLayout } from '/src/layouts';

// eslint-disable-next-line no-empty-pattern
export const RootErrorPage: React.ComponentType<FallbackProps> = ({}) => {
  return (
    <DesktopLayout>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Card component="md-card">
          <Box className="toolbar-div" display="flex" justifyContent="center" alignItems="center" gap="6px">
            <Help className="material-icons md-icon" />
            <Box component="span" className="thin md-display-1">
              Server Error
            </Box>
          </Box>
          <ListItem sx={{ bgcolor: 'white' }}>
            <pre>An error has occurred. Please reload the page and try again.</pre>
          </ListItem>
        </Card>
      </Box>
    </DesktopLayout>
  );
};
